module.exports = __webpack_public_path__ + "media/images/admin2/ModalNewAndEditPackageProduct__panel__body__search-25f2ad79faaff5e23af3b2c5077180a6.svg";